import WinBase from "./winBase";
import {GoingUtils} from "goingutils";

class ShowTreeWin extends WinBase {
    constructor(options) {
        super(options);
        this.options = {};
        let defConfig = {};
        this.options = $.extend(defConfig, options);
    }

    /**
     * 激活form窗口对象
     * @param vueObj
     * @returns {*}
     */
    showWin(vueObj) {
        let divId = GoingUtils.getUUid(12);
        let {search = false} = this.options.config;
        let htmlContent = `<div id='${divId}' class="wh100b" style="height:calc(100% - 40px)"></div>`;
        //如果需要查询区域
        if (search) {
            htmlContent = `<div class="wh100b">
                                <div id="${divId}_search" class="go-tree-ctl" style="height: 33px">
                                    <div  class="search-div">
                                        <div  class="input-icon account-sel-div">
                                            <input AUTOCOMPLETE="off" type="text" placeholder="输入查询值" class="form-control" style=" border: 0;">
                                            <div  class="search-btn"><i  class="ivu-icon ivu-icon-ios-search-outline" style="font-size: 18px;"></i></div>
                                         </div>
                                     </div>
                                </div>
                                <div id='${divId}' style="height:calc(100% - 73px)"></div>
                         </div>`;
        }
        //弹出窗口
        this.showDialogWin(htmlContent,this.options["closeWin"]);
        //初始化容器的高度
        this.initWinContainer(divId,search);
        //激活树
        let treeObj = (this).attachTreeObj(divId);
        //初始化底部操作栏
        this.addBottomBar(divId,this.options.leftBtns);
        //初始化底部事件
        this.initBottomEvent({divId, goAclWin:treeObj, vueObj,treeObj,leftBtns:this.options.leftBtns,closeWin:this.options["closeWin"]});
        //如果存在查询功能
        if (search) {
            $(`#${divId}_search`).find(".search-btn").click(function () {
                let searchStr=$(this).prev().val();
                treeObj.findItem(searchStr);
            });
        }
    }

    //初始化容器的高度

    initWinContainer(divId) {
        $("#" + divId).closest(".layui-layer-content").css("overflow", "hidden");
    }
}

export default ShowTreeWin;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/go-dialog/components/showTreeWin.js